import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { StrictMode } from "react";
import { render } from "react-dom";
import { RecoilRoot } from "recoil";
import RecoilizeDebugger from "recoilize";
import "./assets/datadog-instrumentation";
import RootContainer from "./containers/RootContainer";
import queryClient from "./services/queryClient";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/search/lib/styles/index.css";
import "./styles/amplify.css";
import "./styles/fonts.css";
import "./styles/image-marker.css";
import "./styles/index.css";
import "./styles/mui.css";
import "./styles/react-editor.css";
import "./styles/uppy.css";

const root = document.getElementById("root");

render(
  <StrictMode>
    <RecoilRoot>
      <RecoilizeDebugger root={root} />
      <QueryClientProvider client={queryClient}>
        <RootContainer />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </RecoilRoot>
  </StrictMode>,
  root
);
